export default __webpack_public_path__ + "static/media/offer_deals_banner.777f20e1.svg";